import { createRoot, createSignal, onMount } from 'solid-js';
import { getCookie } from '../tools/cookie-helpers';

/**
 * UNUSED as of 2026-05-06.
 *
 * Originally backed the "filled vs outlined heart" affordance in the header /
 * mobile menu — filled when the `myContent` cookie had at least one bookmark.
 * That UX was dropped because the only signal we have on the server is the
 * default `false`, so SSR always rendered an outline that flipped to filled
 * after hydration — a flash that read as inconsistency to users. Header and
 * mobile menu now always render the outline icon.
 *
 * `setMyContentHasItems` is still called from `my-content-helpers.ts`'s
 * add/delete paths, but no consumer reads `myContentHasItems`. Kept around in
 * case we resurrect a "you have bookmarks" indicator with proper SSR hydration
 * (see boot-server cookie plumbing) — otherwise this file and the writes in
 * my-content-helpers can be deleted.
 */
function createMyContentStore() {
    const [myContentHasItems, setMyContentHasItems] = createSignal(false);

    onMount(() => {
        const cookieValue = getCookie('myContent');

        if (cookieValue === '[]' || !cookieValue) {
            setMyContentHasItems(false);
        } else {
            setMyContentHasItems(true);
        }
    });

    return {
        myContentHasItems,
        setMyContentHasItems,
    };
}

export default createRoot(createMyContentStore);
